import StopPaymentHistoryPage from "components/pages/StopPaymentHistoryPage";

export default function CaptureStopPaymentHistory(props) {
    return <StopPaymentHistoryPage />
}